import { render, staticRenderFns } from "./DichVuVanTaiKhachForm.vue?vue&type=template&id=35e2176b&scoped=true"
import script from "./DichVuVanTaiKhachForm.vue?vue&type=script&lang=js"
export * from "./DichVuVanTaiKhachForm.vue?vue&type=script&lang=js"
import style0 from "./DichVuVanTaiKhachForm.vue?vue&type=style&index=0&id=35e2176b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e2176b",
  null
  
)

export default component.exports